<template>
    <cadastro-simples-form
        endpoint="pais"
        rota-base="/admin/pais"
        titulo-singular="País"
        :campos-extras='[
            { campo: "nacionalidade", label: "Nacionalidade", span: 12 },
            { campo: "ddi", label: "DDI", span: 6 },
            { campo: "cod_censo", label: "Código Censo (INEP)", span: 6 }
        ]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
